<template>
  <div
    @click="goto('pageTop')"
    :class="['scroll-to-top', { mb44: coupleApplied }]"
    v-if="currentStatus"
    :falseProp="cartQuantity"
  >
    <i class="jfi-arrow-double"></i>
  </div>
</template>

<script>
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import { keyMapsGetter } from "../helpers/storeKeys";

export default {
  name: "ScrollToTop",
  data() {
    return {
      currentStatus: 0,
      coupleApplied: 0,
      isHome: true,
    };
  },
  mounted() {
    if (Utility.isSeparateMenuVariant()) {
      this.isHome = false;
    }
    window.addEventListener("scroll", () => {
      let value = window.pageYOffset;
      if (value > 200) {
        this.currentStatus = 1;
      } else {
        this.currentStatus = 0;
      }
      this.checkForCouponMargin(this.isHome);
    });
  },
  methods: {
    goto(itmId) {
      if (itmId) {
        Utility.scrollUptoTo(itmId);
      }
      //Amplitude click event load
      const preEventObj = { scrollType: "up" };
      const eventObj = Utility.amplitudeEventObj(
        "click",
        "bottom menu",
        "-1",
        preEventObj
      );
      setEvents("amplitude", "Click", eventObj);
    },
    checkForCouponMargin(flag = false) {
      const obj = document.querySelector(".offer-applied-message");
      const dealModule = document.querySelector(".deal-offer-container");
      if (flag) {
        if (obj || dealModule) {
          this.coupleApplied = 1;
        } else {
          this.coupleApplied = 0;
        }
      } else {
        if (this.cartQuantity && (obj || dealModule)) {
          this.coupleApplied = 1;
        } else {
          this.coupleApplied = 0;
        }
      }
    },
  },
  computed: {
    cartQuantity() {
      const _ = this.$store.getters[keyMapsGetter.CART_QUANTITY];
      if (Utility.isSeparateMenuVariant()) {
        if (!_) {
          this.coupleApplied = 0;
        } else {
          this.checkForCouponMargin(true);
        }
      }
      return _;
    },
  },
};
</script>
